import CrudService from "../core/crud-service";

export default class TodosService extends CrudService {
  static route = "todos";
}
